import React from 'react';
import { UnassignedEmails } from './components/UnassignedEmails';
import './styles/EmailsTab.css';

/**
 * EmailsTab - Manage unassigned emails
 *
 * This tab provides functionality to:
 * - View emails without affaire association
 * - Associate emails to affaires (by case_number or affaire_id)
 * - Assign emails to users or roles
 * - Discard irrelevant emails
 *
 * Access: Admin and Bureau roles only
 */
export const EmailsTab: React.FC = () => {
  return <UnassignedEmails />;
};

export default EmailsTab;
